import {LoadingSkeleton} from '@/components/app/feedback';
import {cn} from '@/lib/utils';
export interface PhraseSkeletonProps {
  className?: string;
}
export const BiobookPageSkeleton = ({className}: PhraseSkeletonProps) => {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      <div className="flex items-center">
        <LoadingSkeleton height="2rem" shape="rectangle" width="8rem" />
        <LoadingSkeleton className="ml-auto" shape="circle" size="2rem" />
        <LoadingSkeleton className="ml-2" shape="circle" size="2rem" />
      </div>
      <div className="flex flex-col gap-2">
        <LoadingSkeleton height="2rem" shape="rectangle" width="100%" />
        <LoadingSkeleton height="2rem" shape="rectangle" width="100%" />
        <LoadingSkeleton height="2rem" shape="rectangle" width="100%" />
      </div>
      <div className="flex items-center gap-4">
        <LoadingSkeleton height="2rem" shape="rectangle" width="8rem" />
        <LoadingSkeleton height="2rem" shape="rectangle" width="8rem" />
        <LoadingSkeleton className="ml-auto" height="2rem" shape="rectangle" width="8rem" />
      </div>
    </div>
  );
};
